import request from '@/service/request'

// 获取推廣市場
export function getMarketRegions(data) {
  return request({
    url: '/api/v3/common/get-market-regions',
    method: 'get',
    data
  })
}

// 获取国家（简称）
export function getIsoCountries(data) {
  return request({
    url: '/api/v3/common/get-iso-countries',
    method: 'get',
    data
  })
}

// 获取国家（全称）
export function getCountries(data) {
  return request({
    url: '/api/v3/common/get-country-list',
    method: 'get',
    data
  })
}

// 获取code table
export function getMultipleCodeList(data) {
  return request({
    url: '/api/v3/common/get-multiple-code-list',
    method: 'get',
    data
  })
}

// 取得檔案
export function getFile(data) {
  return request({
    url: '/api/v3/common/get-file',
    method: 'get',
    data
  })
}

// 上傳檔案
export function uploadFile(data) {
  return request({
    url: '/api/v3/common/upload-file',
    method: 'post',
    headers: { "Content-Type": "multipart/form-data" },
    data,
    noJson: true
  })
}

// 刪除檔案
export function deleteFile(data) {
  return request({
    url: '/api/v3/common/delete-file',
    method: 'post',
    data
  })
}

// 获取银行列表
export function getBankList(data) {
  return request({
    url: '/api/v3/common/get-bank-list',
    method: 'get',
    data
  })
}

// 联系我们 - 送信
export function contactUs(data) {
  return request({
    url: '/api/v3/common/contact-us',
    method: 'post',
    data
  })
}

// 管理员市场权限
export function getManageMarketListApi(data) {
  return request({
    url: '/api/v3/common/get-business-list',
    method: 'get',
    data
  })
}

// 上传图片
export function uploadImageApi(data) {
  return request({
    url: '/api/v3/common/upload-image',
    method: 'post',
    headers: { "Content-Type": "multipart/form-data" },
    data,
    noJson: true
  })
}

// 批量上传图片
export function uploadBatchImageApi(data) {
  return request({
    url: '/api/v3/common/batch-upload-image',
    method: 'post',
    headers: { "Content-Type": "multipart/form-data" },
    data,
    noJson: true
  })
}

// 下载多图
export function downloadImage(data) {
  return request({
    url: '/api/v3/common/download-image',
    method: 'post',
    data
  })
}

// 检测联盟网站平台url是否存在
export function checkWebPlatformUrlExists(data) {
  return request({
    url: '/api/v3/common/check-web-platform-url-exists',
    method: 'get',
    data
  })
}
